import React, { useState, useEffect } from "react"
import classNames from "classnames"
import OpportunitySearchForm from "../../../../forms/OpportunitySearchForm"
import { setSearchQuery } from "../../useSearch/actionCreators"
import styles from "./index.module.scss"

const SearchFormWrapper = ({ state, dispatch }) => {
  const { type, account_type } = state.requestResultGroup
  const [query, setQuery] = useState(state.requestResultGroup.query)
  useEffect(() => {
    setQuery(state.requestResultGroup.query || "")
  }, [state.requestResultGroup])
    let searchPlaceholder;
    const searchParams = state.searchParamGroup || {}
    switch (account_type) {
        case 'company': {
            // Check if it's filtered for solopreneurs
            if(searchParams.solopreneur === "true" || searchParams.solopreneur === true) {
                searchPlaceholder = "Search for solopreneurs"
            } else {
                searchPlaceholder = "Search for companies"
            }
            break;
        }
        case 'individual': {
            // Check if it's filtered for professionals
            if(searchParams.describe_me === "professionals") {
                searchPlaceholder = "Search for professionals"
            } else {
                searchPlaceholder = "Search for professionals"
            }
            break;
        }
        case 'freelancers': {
            searchPlaceholder = "Search for freelancers"
            break;
        }
    }

    if(type === "companies") {
        searchPlaceholder = "Search for companies";
    }

  return (
    <div className={classNames(styles.searchFormContainer, styles.fullInput)}>
      <OpportunitySearchForm
        emptyMode={false}
        placeholder={searchPlaceholder}
        searchQuery={query}
        onChange={(query) =>
          setQuery(query.length > 200 ? query.substring(0, 200) : query)
        }
        onSearch={() => dispatch(setSearchQuery(query.trim()))}
      />
    </div>
  )
}
export default SearchFormWrapper
